import navbarComponent  from "./navabar.component";

export const NavbarModule = angular
	.module("navbar", [])
	.component("navbar", navbarComponent);


// WEBPACK FOOTER //
// ./sources/components/layout/navbar/navbar.js